<template>
  <div class="outline">
    <header class="light outline">
      <h5 class="comfortaa">Emails</h5>
      <p>Choose a domain for more info</p>
    </header>
    <template v-if="!selectedClient">
      <template v-if="state.user.emails.total > 0">
        <div class="w3-row w3-margin-bottom">
          <table class="w3-table w3-bordered domainResults w3-white" :class="state.width > 1024 ? '' : 'w3-responsive'">
            <tr class="w3-light-grey">
              <td>Domain</td>
              <td class="w3-center" style="min-width:120px;">Status</td>
              <td class="w3-center" style="min-width:90px;">Mailboxes</td>
            </tr>
            <tr v-for="(item, key, i) in state.user.emails" :key="i" class="domainRow">
              <template v-if="item['domainname']">
                <td>{{item["domainname"]}}</td>
                <td class="w3-center">{{item["currentstatus"]}}</td>
                <td class="w3-center">{{item["emailaccounts"]}}</td>
              </template>
            </tr>
          </table>
        </div>
      </template>
      <template v-else>
        <div class="w3-container w3-margin-bottom w3-white">
          <p>No Emails yet, order mailboxes using the 'New Services' menu above</p>
        </div>
      </template>
    </template>
    <!-- <template v-if="selectedClient && selectedClient.email">
      <template v-if="state.admin.client.domains.total > 0">
        <div class="w3-row w3-margin-bottom">
          <table class="w3-table w3-bordered domainResults">
            <tr class="w3-light-grey">
              <td>Domain</td>
              <td class="w3-center" style="width:120px;">Status</td>
              <td class="w3-center" style="width:120px;">Auto Renew</td>
              <td class="w3-center" style="width:120px;">Transfer Lock</td>
            </tr>
            <tr v-for="(item, key, i) in state.admin.client.domains.list" :key="i" class="domainRow">
              <td>{{item["entity.description"]}}</td>
              <td class="w3-center">{{item["entity.currentstatus"]}}</td>
              <td class="w3-center">
                <button class="w3-button w3-small w3-orange" v-if="item['orders.autorenew'] == 'false'">OFF</button>
                <button class="w3-button w3-small w3-green" v-if="item['orders.autorenew'] == 'true'">ON</button>
              </td>
              <td class="w3-center">
                <button class="w3-button w3-small w3-orange" v-if="item['orders.customerlock'] == 'false'">OFF</button>
                <button class="w3-button w3-small w3-green" v-if="item['orders.customerlock'] == 'true'">ON</button>
              </td>
            </tr>
          </table>
        </div>
      </template>
      <template v-else>
        <div class="w3-row-padding w3-margin-bottom">
          <p>No Domains yet, search for a domain or place a transfer order</p>
        </div>
      </template>
    </template> -->
  </div>
</template>

<script>
var dataStore = require("../dataStore").default;

export default {
  name: 'emailsList',
  props: {
    selectedClient: Object
  },
  data () {
    return {
      state: dataStore.state
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/emailsList.vue